import { useState } from "react";
import Button from "../Button/Button.component";
import { Link } from "react-router-dom";

const Accordion = ({ data }) => {
  const [open, setOpen] = useState(null);

  const handleOpen = (index) => {
    setOpen(index === open ? null : index);
  };

  return (
    <section className="accordion">
      <article className="accordion__Card">
        <div
          onClick={() => handleOpen(data.id)}
          className="accordion__Container"
        >
          <span>{data.heading}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={3}
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
        </div>
        <div>
          {open === data.id && (
            <section className="accordion__Visible">
              {data.details.includes("contact form") ? (
                <>
                  {data.details.split("contact form")[0]}

                  <Link
                    to="/contact"
                    className="cursor-pointer underline-noen font-[500]"
                  >
                    contact form
                  </Link>

                  {data.details.split("contact form")[1]}
                </>
              ) : (
                data.details
              )}
            </section>
          )}
        </div>
      </article>
    </section>
  );
};

export default Accordion;
// Career Accordion :
export const CareerAccordion = ({ data }) => {
  const [open, setOpen] = useState();

  const handleOpen = (index) => {
    setOpen(index === open ? null : index);
  };

  return (
    <section data-testid="career-accordion" className="careerAccordion">
      <article className="careerAccordion__Card">
        <div
          onClick={() => handleOpen(data.id)}
          className={
            open === data.id
              ? "careerAccordion__Select"
              : "careerAccordion__Normal"
          }
        >
          <div className="careerAccordion__Text">{data.city}</div>
          <div className="careerAccordion__Text">{data.contract}</div>
          <div className="careerAccordion__Role">{data.role}</div>
        </div>
        <div>
          {open === data.id && (
            <section className="careerAccordion__Visible">
              <div className="flex-1"></div>
              <div className="flex-1"></div>
              <div className="careerAccordion__VisibleData">
                {data.details}
                <Button className="button__White uppercase" text="Apply" />
              </div>
            </section>
          )}
        </div>
      </article>
    </section>
  );
};

export const ByorAccordion = ({ data, isOpen, onToggle }) => {
  return (
    <section className="accordion">
      <article className="accordion__Card">
        <div
          onClick={onToggle}
          className="accordion__Container hover:bg-gray-50 transition-colors"
        >
          <span className="text-[#042E3E] text-[16px] font-[400]">
            {data.question}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={3}
            stroke="currentColor"
            className={`w-6 h-6 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>

        <div
          className={`accordion__Visible text-[#042E3E] text-[16px] font-[400] overflow-hidden transition-all duration-500 ${
            isOpen ? "max-h-96 py-4 " : "max-h-0 py-0"
          }`}
        >
          <div className="text-[#042E3E] text-[16px] font-normal px-2 border-t-slate-200 border-t border-solid py-8">
            {data.answer}
          </div>
        </div>
      </article>
    </section>
  );
};
